// extracted by mini-css-extract-plugin
export default {"ldio":"Spinner_ldio__Ll0hx","loadingioSpinner":"Spinner_loadingioSpinner__lC6eU"};